// SECURE PRODUCTION API BASE URL
// const API_BASE_URL = "https://ms-smpp.nexah.net";

// UNSECURE PRODUCTION API BASE URL
// const API_BASE_URL = "http://3.136.152.137:8080";

// K8 PRODUCTION API BASE URL
const API_BASE_URL = "NXH_API_BASE_URL_PLACEHOLDER";

export const AUTH_API_URL = `${API_BASE_URL}/api/auth/token`;
export const AUTH_URL = "https://myaccount-preprod.nexah.net/";
export const APP_API_URL = `${API_BASE_URL}/api/`;
export const AUTH_SIGN_IN_URL = `/sign-in`;